/* eslint-disable max-len */
import React from "react";

import type { IconName } from "../models";

import styles from "../HomePage.module.css";

type LineIconProps = {
	name: IconName;
};

const LineIcon = ({ name }: LineIconProps) => {
	return (
		<svg aria-hidden="true" className={styles.icon} fill="none" focusable="false" viewBox="0 0 24 24">
			{name === "bell" && (
				<>
					<path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6Z" />
					<path d="M10 19a2 2 0 0 0 4 0" />
				</>
			)}
			{name === "chevronDown" && <path d="m7 10 5 5 5-5" />}
			{name === "chevronLeft" && <path d="m14 7-5 5 5 5" />}
			{name === "chevronRight" && <path d="m10 7 5 5-5 5" />}
			{name === "refresh" && (
				<>
					<path d="M20 11A8 8 0 0 0 5.6 7.2" />
					<path d="M5 3v4.5h4.5" />
					<path d="M4 13a8 8 0 0 0 14.4 3.8" />
					<path d="M19 21v-4.5h-4.5" />
				</>
			)}
			{name === "camera" && (
				<>
					<path d="M4.5 8.5h2.6l1.4-2h7l1.4 2h2.6a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 18v-8a1.5 1.5 0 0 1 1.5-1.5Z" />
					<circle cx="12" cy="13.5" r="3.2" />
				</>
			)}
			{name === "trash" && (
				<>
					<path d="M4.5 7h15" />
					<path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7" />
					<path d="M6.5 7l.8 11a1.5 1.5 0 0 0 1.5 1.4h6.4a1.5 1.5 0 0 0 1.5-1.4L17.5 7" />
					<path d="M10 11v5" />
					<path d="M14 11v5" />
				</>
			)}
			{name === "tree" && (
				<>
					<path d="M12 21v-8" />
					<path d="M7 17c-2.2 0-4-1.7-4-3.9 0-1.8 1.1-3.2 2.7-3.7A5.7 5.7 0 0 1 17 8.4c2.3.4 4 2.3 4 4.7 0 2.7-2.1 4.9-4.9 4.9" />
					<path d="m8.4 12.9 3.6 2.7 3.6-2.7" />
				</>
			)}
			{name === "people" && (
				<>
					<path d="M9 11a3.2 3.2 0 1 0 0-6.4A3.2 3.2 0 0 0 9 11Z" />
					<path d="M3.5 20c.6-3.4 2.4-5.1 5.5-5.1s4.9 1.7 5.5 5.1" />
					<path d="M16 11.2a2.8 2.8 0 1 0-.7-5.5" />
					<path d="M15.8 14.8c2.6.2 4.1 1.9 4.7 5.2" />
				</>
			)}
			{name === "person" && (
				<>
					<path d="M12 11a3.7 3.7 0 1 0 0-7.4A3.7 3.7 0 0 0 12 11Z" />
					<path d="M5 20c.7-4 2.8-6 7-6s6.3 2 7 6" />
				</>
			)}
			{name === "place" && (
				<>
					<path d="M12 20c3.8-4.5 5.7-7.8 5.7-10A5.7 5.7 0 0 0 6.3 10c0 2.2 1.9 5.5 5.7 10Z" />
					<circle cx="12" cy="10" r="2.3" />
				</>
			)}
			{name === "object" && (
				<>
					<path d="m12 3.8 7 4v8.3l-7 4-7-4V7.8l7-4Z" />
					<path d="m19 7.8-7 4.1-7-4.1" />
					<path d="M12 11.9V20" />
				</>
			)}
			{name === "creature" && (
				<>
					<path d="M12 12.6c2.6 0 4.7 1.9 4.7 4.2 0 1.6-1.1 2.7-2.6 2.7-.8 0-1.5-.3-2.1-.3s-1.3.3-2.1.3c-1.5 0-2.6-1.1-2.6-2.7 0-2.3 2.1-4.2 4.7-4.2Z" />
					<ellipse cx="7" cy="10.2" rx="1.7" ry="2.1" />
					<ellipse cx="17" cy="10.2" rx="1.7" ry="2.1" />
					<ellipse cx="10" cy="6.6" rx="1.7" ry="2.2" />
					<ellipse cx="14" cy="6.6" rx="1.7" ry="2.2" />
				</>
			)}
			{name === "organization" && (
				<>
					<path d="M12 3.5 19 6v5.2c0 4.4-2.8 7.3-7 9.3-4.2-2-7-4.9-7-9.3V6l7-2.5Z" />
					<path d="M12 8v4.5" />
					<path d="M9.8 10.2h4.4" />
				</>
			)}
			{name === "event" && (
				<>
					<rect height="14.5" rx="2" width="17" x="3.5" y="5" />
					<path d="M8 3v4" />
					<path d="M16 3v4" />
					<path d="M3.5 10h17" />
					<path d="M8 14h3" />
				</>
			)}
			{name === "species" && (
				<>
					<path d="M8 3.5c0 4.8 8 4.8 8 8.5s-8 3.7-8 8.5" />
					<path d="M16 3.5c0 4.8-8 4.8-8 8.5s8 3.7 8 8.5" />
					<path d="M8.7 6.5h6.6" />
					<path d="M8.7 17.5h6.6" />
				</>
			)}
			{name === "custom" && (
				<>
					<rect height="6.5" rx="1.2" width="6.5" x="4" y="4" />
					<circle cx="16.8" cy="7.2" r="3.3" />
					<path d="m7.2 13.5 3.2 6H4l3.2-6Z" />
					<path d="M16.8 13.8v6" />
					<path d="M13.8 16.8h6" />
				</>
			)}
			{name === "compass" && (
				<>
					<circle cx="12" cy="12" r="8.5" />
					<path d="m15.4 8.6-2.1 5.1-5.1 2.1 2.1-5.1 5.1-2.1Z" />
				</>
			)}
			{name === "settings" && (
				<>
					<path d="M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z" />
					<path d="m19 13.4 1.4 1.1-2 3.5-1.8-.7a7.5 7.5 0 0 1-1.8 1.1l-.3 1.9h-4l-.3-1.9a7.5 7.5 0 0 1-1.8-1.1l-1.8.7-2-3.5L5 13.4a7.9 7.9 0 0 1 0-2.8L3.6 9.5l2-3.5 1.8.7a7.5 7.5 0 0 1 1.8-1.1l.3-1.9h4l.3 1.9a7.5 7.5 0 0 1 1.8 1.1l1.8-.7 2 3.5L19 10.6a7.9 7.9 0 0 1 0 2.8Z" />
				</>
			)}
			{name === "card" && (
				<>
					<rect height="13" rx="2.4" width="18" x="3" y="5.5" />
					<path d="M3 10h18" />
					<path d="M7 14.5h4" />
				</>
			)}
			{name === "save" && (
				<>
					<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z" />
					<path d="M17 21v-8H7v8" />
					<path d="M7 3v5h8" />
				</>
			)}
			{name === "search" && (
				<>
					<circle cx="11" cy="11" r="6.5" />
					<path d="m16 16 4 4" />
				</>
			)}
			{name === "plus" && (
				<>
					<path d="M12 5v14" />
					<path d="M5 12h14" />
				</>
			)}
			{name === "minus" && <path d="M5 12h14" />}
			{name === "heart" && (
				<path d="M20.2 6.8c-1.8-2.2-5.2-1.9-6.8.5L12 9.2l-1.4-1.9C9 4.9 5.6 4.6 3.8 6.8 1.7 9.3 2.6 13 5.2 15l6.8 5 6.8-5c2.6-2 3.5-5.7 1.4-8.2Z" />
			)}
			{name === "clock" && (
				<>
					<circle cx="12" cy="12" r="8.5" />
					<path d="M12 7.6V12l3.2 2" />
				</>
			)}
			{name === "logout" && (
				<>
					<path d="M10 6H6.8A2.8 2.8 0 0 0 4 8.8v6.4A2.8 2.8 0 0 0 6.8 18H10" />
					<path d="M14 8l-4 4 4 4" />
					<path d="M10 12h10" />
				</>
			)}
			{name === "close" && (
				<>
					<path d="M18 6 6 18" />
					<path d="m6 6 12 12" />
				</>
			)}
			{name === "menu" && (
				<>
					<path d="M4 7h16" />
					<path d="M4 12h16" />
					<path d="M4 17h16" />
				</>
			)}
			{name === "upload" && (
				<>
					<path d="M12 16V7" />
					<path d="m8.5 10.5 3.5-3.5 3.5 3.5" />
					<path d="M5.5 16.5a4 4 0 0 1 .3-7.9A5.5 5.5 0 0 1 16.4 7 4.8 4.8 0 0 1 18 16.5" />
					<path d="M6 20h12" />
				</>
			)}
			{name === "eye" && (
				<>
					<path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
					<circle cx="12" cy="12" r="3.2" />
				</>
			)}
			{name === "pencil" && (
				<>
					<path d="M5 19 6.2 14.4 15.3 5.3a2 2 0 0 1 2.8 2.8L9 17.2 5 19Z" />
					<path d="m13.8 6.8 3.4 3.4" />
				</>
			)}
			{name === "lock" && (
				<>
					<rect height="9" rx="2" width="13" x="5.5" y="10.5" />
					<path d="M8.5 10.5V8a3.5 3.5 0 0 1 7 0v2.5" />
					<path d="M12 14v2" />
				</>
			)}
			{name === "globe" && (
				<>
					<circle cx="12" cy="12" r="8.5" />
					<path d="M3.8 12h16.4" />
					<path d="M12 3.5c2.2 2.3 3.4 5.1 3.4 8.5S14.2 18.2 12 20.5" />
					<path d="M12 3.5C9.8 5.8 8.6 8.6 8.6 12s1.2 6.2 3.4 8.5" />
				</>
			)}
			{name === "star" && (
				<path d="M12 4.5l2.3 4.7 5.2.8-3.8 3.7.9 5.1-4.6-2.4-4.6 2.4.9-5.1L4.5 10l5.2-.8L12 4.5Z" />
			)}
			{name === "starFilled" && (
				<path
					d="M12 4.5l2.3 4.7 5.2.8-3.8 3.7.9 5.1-4.6-2.4-4.6 2.4.9-5.1L4.5 10l5.2-.8L12 4.5Z"
					fill="currentColor"
					stroke="currentColor"
				/>
			)}
			{name === "sparkle" && (
				<>
					<path d="M12 3.5 13.7 9l5.3 1.7-5.3 1.8L12 18l-1.8-5.5L5 10.7 10.2 9 12 3.5Z" />
					<path d="m18.5 15 .7 2.1 2 .7-2 .7-.7 2.1-.7-2.1-2.1-.7 2.1-.7.7-2.1Z" />
					<path d="m5 3.5.6 1.7 1.7.6-1.7.6L5 8l-.6-1.6-1.7-.6 1.7-.6L5 3.5Z" />
				</>
			)}
		</svg>
	);
};

export default LineIcon;
